import { getChannel } from './channel'

export const setupOperaSDK = async () => {
  if (window.otag || process.env.VUE_APP_Online !== 'true') {
    return
  }

  try {
    !(function (p, l, o, w, i, n, g) {
      if (!p[i]) {
        p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || []
        p.GlobalSnowplowNamespace.push(i)
        p[i] = function () {
          ;(p[i].q = p[i].q || []).push(arguments)
        }
        p[i].q = p[i].q || []
        n = l.createElement(o)
        g = l.getElementsByTagName(o)[0]
        n.async = 1
        n.src = w
        g.parentNode.insertBefore(n, g)
      }
    })(window, document, 'script', '//res-odx.op-mobile.opera.com/sp.js', 'otag')

    window.otag('init', 'adv9820378197952_12502050309376_v2')
  } catch (error) {
    console.error(error)
  }
}

export const trackOperaReg = () => {
  const channel = getChannel()
  if (/^opera_dsp_/.test(channel)) {
    window.otag && window.otag('event', 'registration')
  }
}
